import { render, staticRenderFns } from "./alarmaVienw.vue?vue&type=template&id=477ee9d8"
import script from "./alarmaVienw.vue?vue&type=script&lang=js"
export * from "./alarmaVienw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports